import type { TGlobalDataModelInvestment } from '@/_models';

import { sanitizeCourseIds } from './sanitize-ids';

export function useCourseSelection(investment: TGlobalDataModelInvestment) {
  const {
    selectedAddonCourseIds,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    selectedAddonCourses,
    selectedPrepCourseIds,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    selectedAtpCourses,
    selectedOdtCourseIds,
    selectedFundamentalCourseIds,
  } = investment;

  const getCourseSelection = ({
    planPrepCourseIds,
    planAddonCourseIds,
    planOdtCourseIds,
    planFundamentalCourseIds,
  }: {
    planPrepCourseIds: string[];
    planAddonCourseIds: string[];
    planOdtCourseIds: string[];
    planFundamentalCourseIds: string[];
  }) => {
    const storedAtpCourseIds = selectedPrepCourseIds ?? selectedAtpCourses;
    const storedOptionalCourseIds = selectedAddonCourseIds ?? selectedAddonCourses;
    const storedOdtCourseIds = selectedOdtCourseIds ?? [];
    const storedFundamentalCourseIds = selectedFundamentalCourseIds ?? [];

    const {
      selectedPrepCourseIds: sanitizedPrepCourseIds,
      selectedAddonCourseIds: sanitizedAddonCourseIds,
      selectedOdtCourseIds: sanitizedOdtCourseIds,
      selectedFundamentalCourseIds: sanitizedFundamentalCourseIds,
    } = sanitizeCourseIds({
      planPrepCourseIds,
      planAddonCourseIds,
      planOdtCourseIds,
      planFundamentalCourseIds,

      storedAtpCourseIds,
      storedOptionalCourseIds,
      storedOdtCourseIds,
      storedFundamentalCourseIds,
    });

    const allSelectedCourseIds = [
      ...sanitizedPrepCourseIds,
      ...sanitizedAddonCourseIds,
      ...sanitizedOdtCourseIds,
      ...sanitizedFundamentalCourseIds,
    ];

    const totalSelectedPrepCourses = [...sanitizedPrepCourseIds, ...sanitizedAddonCourseIds].length;
    const totalSelectedOdtCourses = sanitizedOdtCourseIds?.length ?? 0;
    const totalSelectedFundamentalCourses = sanitizedFundamentalCourseIds?.length ?? 0;
    const totalSelectedCourses = allSelectedCourseIds.length;

    return {
      allSelectedCourseIds,
      totalSelectedCourses,
      totalSelectedPrepCourses,
      totalSelectedOdtCourses,
      totalSelectedFundamentalCourses,
    };
  };

  return { getCourseSelection };
}
